module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav"
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "mode": "horizontal",
      "menu-trigger": "click",
      "unique-opened": true
    }
  }, [_c('el-menu-item', {
    staticStyle: {
      "height": "55px"
    },
    attrs: {
      "index": "/"
    }
  }, [_c('router-link', {
    staticClass: "nav-a",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("突发环境事件应急预案")])], 1), _vm._v(" "), _c('el-menu-item', {
    staticStyle: {
      "height": "55px"
    },
    attrs: {
      "index": "/Weatherplan"
    }
  }, [_c('router-link', {
    staticClass: "nav-a",
    attrs: {
      "to": _vm.pathUrl
    }
  }, [_vm._v("重污染天气应急预案")])], 1), _vm._v(" "), _c('el-menu-item', {
    staticStyle: {
      "height": "55px"
    },
    attrs: {
      "index": "/myunit"
    }
  }, [_c('router-link', {
    staticClass: "nav-a",
    attrs: {
      "to": _vm.pathUrl2
    }
  }, [_vm._v("申报单位")])], 1), _vm._v(" "), _c('el-menu-item', {
    staticStyle: {
      "height": "55px"
    },
    attrs: {
      "index": "/manage/guidefile"
    }
  }, [_c('router-link', {
    staticClass: "nav-a",
    attrs: {
      "to": _vm.pathUrl3
    }
  }, [_vm._v("法律法规")])], 1), _vm._v(" "), _c('el-menu-item', {
    staticStyle: {
      "height": "55px"
    },
    attrs: {
      "index": "/expert/list"
    }
  }, [_c('router-link', {
    staticClass: "nav-a",
    attrs: {
      "to": _vm.pathUrl4
    }
  }, [_vm._v("专家库")])], 1), _vm._v(" "), _c('el-menu-item', {
    staticStyle: {
      "height": "55px"
    },
    attrs: {
      "index": "/user"
    }
  }, [_c('router-link', {
    staticClass: "nav-a",
    attrs: {
      "to": _vm.pathUrl5
    }
  }, [_vm._v("个人资料")])], 1), _vm._v(" "), _c('el-menu-item', {
    staticStyle: {
      "height": "55px"
    },
    attrs: {
      "index": ""
    }
  }, [_c('a', {
    staticStyle: {
      "font-size": "16px",
      "line-height": "55px"
    },
    attrs: {
      "target": "_blank",
      "href": "https://biaoqi8.yuque.com/docs/share/409b86f8-f7f5-42e6-8622-e6324906b356"
    }
  }, [_vm._v("\n          帮助手册\n        ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-921b6be0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/component/nav.vue
// module id = 1265
// module chunks = 2